import {
  FormFieldConfigType,
  INPUT_TYPES,
  TEXT_INPUT_TYPES,
  RADIO_YES_NO,
} from "../../../../types";
import { preProcessFormFields } from "../../../../tools";
import { CLAIM_INFORMATION_CONSTANTS } from "../../../constants";
import {
  TACT_COUNTRIES,
  INCIDENT_TYPE_OPTIONS,
  SUPPORTED_SEDGWICK_IPL_INCIDENT_COUNTRIES,
} from "../../../options";

export const formFieldsConfig: FormFieldConfigType[] = [
  {
    name: CLAIM_INFORMATION_CONSTANTS.FORM_NAME,
    type: INPUT_TYPES.FIELD_GROUP,
    contained: true,
    label: CLAIM_INFORMATION_CONSTANTS.FORM_HEADER,
    description: CLAIM_INFORMATION_CONSTANTS.FORM_DESCRIPTION,
    fields: [
      {
        name: CLAIM_INFORMATION_CONSTANTS.DATE_OF_LOSS,
        label: "Date of Loss",
        description: "",
        type: INPUT_TYPES.DATE_PICKER,
      },
      {
        name: CLAIM_INFORMATION_CONSTANTS.CUSTOMER_FIRST_NAME,
        label: "Customer First Name",
        type: INPUT_TYPES.TEXT,
        textInputType: TEXT_INPUT_TYPES.DEFAULT,
        placeholderText: "",
      },
      {
        name: CLAIM_INFORMATION_CONSTANTS.CUSTOMER_LAST_NAME,
        label: "Customer Last Name",
        type: INPUT_TYPES.TEXT,
        textInputType: TEXT_INPUT_TYPES.DEFAULT,
        placeholderText: "",
      },
      {
        name: CLAIM_INFORMATION_CONSTANTS.IS_INSURER_OR_REPRESENTATIVE_APPLICABLE,
        label: "Is the Insurer or Representative name available for this claim?",
        type: INPUT_TYPES.RADIO,
        options: RADIO_YES_NO,
        onChange: (
          { detail }: { detail: any },
          formState: any,
          updateForm: (formState: any) => void
        ) => {
          const isApplicable = detail.value === "true";
          updateForm({
            ...formState,
            [CLAIM_INFORMATION_CONSTANTS.IS_INSURER_OR_REPRESENTATIVE_APPLICABLE]: {
              ...formState[CLAIM_INFORMATION_CONSTANTS.IS_INSURER_OR_REPRESENTATIVE_APPLICABLE],
              value: detail.value,
            },
            [CLAIM_INFORMATION_CONSTANTS.INSURER_OR_REPRESENTATIVE_NAME]: {
              ...formState[CLAIM_INFORMATION_CONSTANTS.INSURER_OR_REPRESENTATIVE_NAME],
              hidden: !isApplicable,
              value: isApplicable ? "" : "N/A",
              errors: [],
            },
          });
        },
      },
      {
        name: CLAIM_INFORMATION_CONSTANTS.INSURER_OR_REPRESENTATIVE_NAME,
        label: "Insurer or Representative Name",
        type: INPUT_TYPES.TEXT,
        textInputType: TEXT_INPUT_TYPES.DEFAULT,
        placeholderText: "",
      },
      {
        name: CLAIM_INFORMATION_CONSTANTS.CUSTOMER_ADDRESS,
        type: INPUT_TYPES.FIELD_GROUP,
        header: "Customer Address",
        label: "Customer Address",
        fields: [
          {
            name: CLAIM_INFORMATION_CONSTANTS.ADDRESS_LINE_1,
            label: "Address Line 1",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
            placeholderText: "",
          },
          {
            name: CLAIM_INFORMATION_CONSTANTS.ADDRESS_LINE_2,
            label: "Address Line 2",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
            placeholderText: "",
          },
          {
            name: CLAIM_INFORMATION_CONSTANTS.CITY,
            label: "City",
            type: INPUT_TYPES.TEXT,
            textInputType: TEXT_INPUT_TYPES.DEFAULT,
            placeholderText: "",
          },
          {
            name: CLAIM_INFORMATION_CONSTANTS.COUNTRY,
            label: "Country",
            type: INPUT_TYPES.SELECT,
            options: TACT_COUNTRIES,
            placeholderText: "Select a country",
          },
        ],
      },
      {
        name: CLAIM_INFORMATION_CONSTANTS.CUSTOMER_EMAIL,
        label: "Customer Email",
        type: INPUT_TYPES.TEXT,
        textInputType: TEXT_INPUT_TYPES.EMAIL,
        placeholderText: "",
      },
      {
        name: CLAIM_INFORMATION_CONSTANTS.CUSTOMER_PHONE,
        label: "Customer Phone",
        type: INPUT_TYPES.PHONE,
        textInputType: TEXT_INPUT_TYPES.DEFAULT,
        placeholderText: "",
      },
      {
        name: CLAIM_INFORMATION_CONSTANTS.INCIDENT_TYPE,
        label: "Incident Type",
        type: INPUT_TYPES.SELECT,
        options: INCIDENT_TYPE_OPTIONS,
        placeholderText: "Select incident type",
      },
      {
        name: CLAIM_INFORMATION_CONSTANTS.DESCRIPTION_OF_INCIDENT,
        label: "Description of Incident",
        type: INPUT_TYPES.TEXTAREA,
        placeholderText: "",
      },
      {
        name: CLAIM_INFORMATION_CONSTANTS.COUNTRY_WHERE_INCIDENT_OCCURRED,
        label: "Country Where Incident Occurred",
        type: INPUT_TYPES.SELECT,
        options: SUPPORTED_SEDGWICK_IPL_INCIDENT_COUNTRIES,
        placeholderText: "Select a country",
        description: "These are the currently supported countries",
      },
      {
        name: CLAIM_INFORMATION_CONSTANTS.PRODUCT_PURCHASE_DATE,
        label: "Product Purchase Date",
        description: "",
        type: INPUT_TYPES.DATE_PICKER,
      },
    ],
  },
];

export const formFieldsConfigProcessed = preProcessFormFields(formFieldsConfig);
